/* eslint-disable */
import { base, baseXlsx, baseUpload } from '@/utils/api'
import { getCurrentClinic } from '@/utils/localStorageManager'

const ENDPOINT = '/financial'

export default {
  getCardFlags(clinicId) {
    const config = {
      params: {}
    }
    return base.get(`${ENDPOINT}/clinic/${clinicId}/cardFlags`, config)
  },
  createCardFlag(data) {
    return base.post(`${ENDPOINT}/cardFlags`, data)
  },
  updateCardFlag(id, data) {
    return base.put(`${ENDPOINT}/cardFlags/${id}`, data)
  },
  deleteCardFlag(id) {
    return base.delete(`${ENDPOINT}/cardFlags/${id}`)
  },

  getCardMachines(clinicId) {
    const config = {
      params: {}
    }
    return base.get(`${ENDPOINT}/clinic/${clinicId}/cardMachines`, config)
  },
  createCardMachine(data) {
    return base.post(`${ENDPOINT}/cardMachines`, data)
  },
  updateCardMachine(id, data) {
    return base.put(`${ENDPOINT}/cardMachines/${id}`, data)
  },
  deleteCardMachine(id) {
    return base.delete(`${ENDPOINT}/cardMachines/${id}`)
  },
  getPendingHistoryResume(clinicId, filters) {
    const config = {
      params: { filters }
    }

    return base.get(`items/${clinicId}/pending-history-resume`, config)
  },

  getPaymentMethods(clinicId) {
    const config = {
      params: { clinicId }
    }
    return base.get(`${ENDPOINT}/paymentMethods`, config)
  },
  createPaymentMethod(data) {
    return base.post(`${ENDPOINT}/paymentMethods`, data)
  },
  updatePaymentMethod(id, data) {
    return base.put(`${ENDPOINT}/paymentMethods/${id}`, data)
  },
  deletePaymentMethod(id) {
    return base.delete(`${ENDPOINT}/paymentMethods/${id}`)
  },

  getInstallments(clinicId, page, filters) {
    const config = {
      params: { clinicId, page, ...filters }
    }
    return base.get(`financial/installments`, config)
  },

  getCategories(clinicId, type, showRemoved, allCategories = false) {
    const config = {
      params: { type, showRemoved, allCategories }
    }
    return base.get(`financial/list_categories/${clinicId}`, config)
  },

  getCostCenters(clinicId) {
    return base.get(`financial/costCenters/${clinicId}`)
  },

  getPaymentMethodsBillToReceive(clinicId) {
    return base.get(`financial/get_payment_methods/${clinicId}`)
  },

  getBankAccountBillToReceive(clinicId) {
    return base.get(`financial/get_bank_account/${clinicId}`)
  },

  getBillsExport(clinicId, filters) {
    const config = {
      params: { clinicId, ...filters }
    }
    return baseXlsx.get(`financial/billsExport`, config)
  },

  getCompleteBillsExport(clinicId, filters) {
    const config = {
      params: { clinicId, ...filters }
    }
    return baseXlsx.get(`financial/completeExport`, config)
  },

  getBankAccounts(clinicId) {
    return base.get(`financial/get_bank_account/${clinicId}`)
  },

  // Saldo de fechamento das contas numa data (saldo por data — card 86ahxfe33).
  getBankAccountsBalanceAt(clinicId, date) {
    const config = { params: { date } }
    return base.get(`financial/bank-accounts-balance-at/${clinicId}`, config)
  },

  // Movements
  getFinancialMovements(clinicId, page, filters) {
    const params = { clinicId, page, ...filters }

    if (params.period && typeof params.period === 'object') {
      params.period = JSON.stringify(params.period)
    }

    const config = {
      params
    }
    return base.get(`financial/clinic/${clinicId}/movements`, config)
  },
  createMovement(data) {
    return base.post(`financial/movements`, data)
  },
  updateMovement(id, data) {
    return base.put(`financial/movements/${id}`, data)
  },
  getMovementsCount(bankAccountIds) {
    const config = {
      params: { bank_account_ids: bankAccountIds }
    }
    return base.get(`financial/movements-count`, config)
  },
  getMovementsExport(clinicId, filters) {
    const config = {
      params: { clinicId, ...filters }
    }
    return baseXlsx.get(`financial/movementsExport`, config)
  },

  //CashFlow
  getCashFlowResume(clinicId, bankAccountId, month, year) {
    const config = {
      params: { clinicId, bankAccountId, month, year }
    }
    return base.get(`financial/cash-flow-resume`, config)
  },
  getCashFlow(clinicId, bankAccountIds, dateStart, dateEnd) {
    const config = {
      params: { clinicId, bankAccountIds, dateStart, dateEnd }
    }
    return base.get(`financial/cashFlow`, config)
  },
  getCashFlowIInstallments(clinicId, bankAccountIds, date) {
    const config = {
      params: { clinicId, bankAccountIds, date }
    }
    return base.get(`financial/cash-flow/installments`, config)
  },
  getCashFlowExport(clinicId, bankAccountIds, dateStart, dateEnd) {
    const config = {
      params: { clinicId, bankAccountIds, dateStart, dateEnd }
    }
    return baseXlsx.get(`financial/cash-flow-export`, config)
  },
  getCashFlowChart(clinicId, bankAccountIds, dateStart, dateEnd) {
    const config = {
      params: { clinicId, bankAccountIds, dateStart, dateEnd }
    }
    return base.get(`financial/cash-flow-chart`, config)
  },
  findCategoryByName(name, clinicId = null) {
    const config = {
      params: { name, clinicId }
    }
    return base.get(`financial/category/find-by-name`, config)
  },
  getCreditPatient(clinicId, patientId, categoryId) {
    const config = {
      clinicId,
      patientId,
      categoryId
    }

    return base.get(`financial/patientCredit`, { params: config })
  },
  getCreditPatientCategory(clinicId) {
    return base.get(`financial/${clinicId}/getCreditPatientCategory`)
  },
  getBills(page, filters) {
    const config = {
      params: { page, ...filters }
    }
    return base.get(`financial/bills`, config)
  },

  storeBillAttachment(data) {
    return base.post(`financial/attachment`, data)
  },

  updateBillAttachment(id, data) {
    return base.put(`financial/attachment/${id}`, data)
  },

  deleteBillAttachment(id) {
    return base.delete(`financial/attachment/${id}`)
  },

  getCreditResume(data) {
    const config = {
      params: data
    }
    return base.get(`financial/creditResume`, config)
  },

  // Reconciliation
  getOFXPeriod(file, clinicId) {
    const resolvedClinicId = clinicId ?? getCurrentClinic()?.id ?? null
    const formData = new FormData()
    formData.append('file', file)
    if (resolvedClinicId) {
      formData.append('clinic_id', resolvedClinicId)
    }
    return baseUpload.post(
      `${ENDPOINT}/reconciliation/get_ofx_period`,
      formData
    )
  },
  importOFX(data) {
    const resolvedClinicId = data.clinic_id ?? getCurrentClinic()?.id ?? null
    const formData = new FormData()
    formData.append('file', data.file)
    if (resolvedClinicId) {
      formData.append('clinic_id', resolvedClinicId)
    }
    formData.append('bank_account_id', data.bank_account_id)
    formData.append('period_start', data.period.start)
    formData.append('period_end', data.period.end)
    formData.append('period_status', data.period_status)

    return baseUpload.post(`${ENDPOINT}/reconciliation/import_ofx`, formData)
  },
  getReconciliationTransactions(clinicId, page, filters) {
    const params = {
      clinic_id: clinicId,
      page: page,
      ...filters
    }
    return base.get(`${ENDPOINT}/reconciliation/get_transactions`, { params })
  },
  getReconciliationTransactionsExport(clinicId, userId, tabId, filters) {
    const params = {
      clinic_id: clinicId,
      user_id: userId,
      tab_id: tabId,
      ...filters
    }
    return base.get(`${ENDPOINT}/reconciliation/export_transactions`, {
      params
    })
  },
  reconcileTransactions(data) {
    return base.post(`${ENDPOINT}/reconciliation/reconcile_transactions`, data)
  },
  unreconcileTransactions(data) {
    return base.post(
      `${ENDPOINT}/reconciliation/unreconcile_transactions`,
      data
    )
  },
  searchTransactions(clinicId, page, filters) {
    // POST (e nao GET): os filtros podem ter centenas de exclude_installment_ids,
    // o que estourava o tamanho da URL em GET (erro de conexao). Os filtros vao
    // no corpo; o page segue na query string porque a paginacao do Laravel le de la.
    const body = { clinic_id: clinicId, ...filters }
    return base.post(
      `${ENDPOINT}/reconciliation/search_transactions?page=${page}`,
      body
    )
  },
  updateFinancialTransaction(id, data) {
    return base.put(`${ENDPOINT}/reconciliation/update_transaction/${id}`, data)
  },
  archiveBankReconciliationEntry(entryId) {
    return base.post(`${ENDPOINT}/reconciliation/archive_entry/${entryId}`)
  },
  archiveBankReconciliationEntryByFit(fitId, bankAccountId) {
    return base.post(`${ENDPOINT}/reconciliation/archive_entry_by_fit`, {
      fit_id: fitId,
      bank_account_id: bankAccountId
    })
  },
  unarchiveBankReconciliationEntry(entryId) {
    return base.post(`${ENDPOINT}/reconciliation/unarchive_entry/${entryId}`)
  },
  unarchiveBankReconciliationEntryByFit(fitId, bankAccountId) {
    return base.post(`${ENDPOINT}/reconciliation/unarchive_entry_by_fit`, {
      fit_id: fitId,
      bank_account_id: bankAccountId
    })
  },
  getArchivedReconciliationEntries(bankAccountId, start, end) {
    const params = { bank_account_id: bankAccountId }
    if (start) params.start = start
    if (end) params.end = end
    return base.get(`${ENDPOINT}/reconciliation/archived_entries`, {
      params
    })
  },
  /** Todas as entradas arquivadas de todas as contas da clínica (sem filtro de OFX em sessão), paginado. */
  getArchivedReconciliationEntriesByClinic(
    clinicId,
    start,
    end,
    page = 1,
    perPage = 15
  ) {
    const params = { clinic_id: clinicId, page, per_page: perPage }
    if (start) params.start = start
    if (end) params.end = end
    return base.get(`${ENDPOINT}/reconciliation/archived_entries`, {
      params
    })
  }
}
